/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 14/05/20.
 *
 * Version : Generator 2.0.9
 */

import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {LogService} from './logService';

/**
 * Log Service
 */
@Injectable()
export class LogErrorsHandler extends ErrorHandler {
    /**
     * Constructor
     * @param {Injector} injector
     */
    constructor(private injector: Injector) {
        super();
    }

    /**
     * Handle Error
     * @param {Error} error
     */
    handleError(error: Error) {
        super.handleError(error);
        const logService = this.injector.get(LogService);
        if (logService != null) {
            logService.isReadyToStart().then(
                () => {
                    logService.logErrorError(error);
                }
            );
        }
    }
}
